import React from 'react';
import './side.css'
import Main from './package'
import { getsitedata, logout } from "./../action/user";

function Side() {
  const onlogout = async () => {
    var test = await logout();
    window.location = "/";
  }
  return (
    <>
      <div className='row'>
        <div className='col-md-2'>
          <div className="sidebar">
            <a href='/myprofile'>My Profile</a>
            <a href='/showCard'>Viewed by me</a>
            <a href='/anotherviewed'>Viewed by others</a>
            <a href='/saved'>Favorites</a>
            <a className="active" href='/membership'>Membership Details</a>
            <a onClick={onlogout}>Logout</a>
          </div>
        </div>
        <div className='col-md-10'>

          <div className="contents">
            <Main />
          </div>
        </div>
      </div>
    </>

  );
}
export default Side;


